import React from 'react';

export default function Terms() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-slate-900 py-16">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-white/60 font-medium mb-4 tracking-wide text-sm uppercase">Legal</p>
          <h1 className="text-4xl lg:text-5xl font-light text-white mb-4 leading-tight">
            Terms of
            <span className="block font-semibold">Service</span>
          </h1>
          <p className="text-slate-400 max-w-3xl mx-auto">
            Please read these terms and conditions carefully before using our services.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4">
          <div className="prose prose-slate max-w-none">
            <p className="text-slate-500 mb-8">Last updated: April 2026</p>

            <h2 className="text-2xl font-bold text-slate-800 mb-4">1. Services</h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              Total Repair UK provides emergency drainage and plumbing services, including fault diagnosis, repairs, and related works carried out on a call-out basis.
            </p>
            <p className="text-slate-600 leading-relaxed mb-6">
              All services are subject to availability. We reserve right to refuse service in exceptional circumstances, including but not limited to safety concerns or inaccessible locations.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mb-4">2. Call-Out & Payment</h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              All emergency services are chargeable on a call-out basis.
            </p>
            <p className="text-slate-600 leading-relaxed mb-6">
              Pricing is based on time spent on site and includes call-out, diagnosis, and repair within the applicable time bracket.
            </p>
            <p className="text-slate-600 leading-relaxed mb-6">
              Payment is required in full at time of booking. By requesting our services, you agree to these terms. We accept all major credit and debit cards.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mb-4">3. Pricing & Additional Works</h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              Our standard pricing covers work completed within stated timeframes.
            </p>
            <p className="text-slate-600 leading-relaxed mb-6">
              If your issue requires additional time, parts, or further work beyond the initial call-out, this will be clearly explained and agreed with you before any additional charges are incurred.
            </p>
            <p className="text-slate-600 leading-relaxed mb-6">
              No further work will be carried out without your consent.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mb-4">4. Cancellations & Refunds</h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              As this is an emergency call-out service, no cooling-off period applies once service has been requested and an engineer has been dispatched.
            </p>
            <p className="text-slate-600 leading-relaxed mb-6">
              If you wish to cancel, you must notify us as soon as possible. Cancellation fees may apply if an engineer is already en route or has arrived on site.
            </p>
            <p className="text-slate-600 leading-relaxed mb-6">
              Once work has been carried out, charges are non-refundable.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mb-4">5. Customer Responsibilities</h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              Customers must provide safe and clear access to property and affected area.
            </p>
            <p className="text-slate-600 leading-relaxed mb-6">
              Accurate information about the issue should be provided where possible. We are not responsible for delays or additional costs resulting from incomplete or incorrect information.
            </p>
            <p className="text-slate-600 leading-relaxed mb-6">
              Customers are responsible for any pre-existing issues, hidden defects, or complications not visible at the time of inspection.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mb-4">6. Liability</h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              Total Repair UK will carry out all work with reasonable care and skill.
            </p>
            <p className="text-slate-600 leading-relaxed mb-6">
              We are not liable for indirect or consequential losses, including damage arising from pre-existing faults, structural issues, or previously attempted repairs.
            </p>
            <p className="text-slate-600 leading-relaxed mb-6">
              Customers are advised to secure or remove any valuable or fragile items in the work area prior to our arrival.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mb-4">7. Complaints Procedure</h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              We are committed to providing a high standard of service. If you are not satisfied, please follow the steps below:
            </p>

            <h3 className="text-xl font-semibold text-slate-700 mb-3">Contact Us</h3>
            <p className="text-slate-600 leading-relaxed mb-6">
              Get in touch via phone, email, or our website with your details and a clear description of the issue.
            </p>

            <h3 className="text-xl font-semibold text-slate-700 mb-3">Acknowledgment</h3>
            <p className="text-slate-600 leading-relaxed mb-6">
              We will acknowledge your complaint within 2 business days.
            </p>

            <h3 className="text-xl font-semibold text-slate-700 mb-3">Investigation</h3>
            <p className="text-slate-600 leading-relaxed mb-6">
              We will review all relevant details and may contact you for further information.
            </p>

            <h3 className="text-xl font-semibold text-slate-700 mb-3">Resolution</h3>
            <p className="text-slate-600 leading-relaxed mb-6">
              We aim to resolve complaints within 14 days. If more time is needed, we will keep you informed.
            </p>

            <h3 className="text-xl font-semibold text-slate-700 mb-3">Outcome</h3>
            <p className="text-slate-600 leading-relaxed mb-6">
              You will receive a written response outlining the outcome and any actions taken. If you remain dissatisfied, you may escalate the matter to an appropriate Alternative Dispute Resolution (ADR) provider.
            </p>
            <p className="text-slate-600 leading-relaxed mb-6">
              This process does not affect your statutory rights.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mb-4">8. Governing Law</h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              These terms are governed by the laws of England and Wales.
            </p>
            <p className="text-slate-600 leading-relaxed mb-6">
              Any disputes will be subject to the exclusive jurisdiction of the courts of England and Wales.
            </p>
          </div>
        </div>
      </section>

    </div>
  );
}
